// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mVBSd","rootMobile":"styles_rootMobile__34qFl"};